<div class="container-fluid dashboard">
  <!-- Welcome Header -->
  <div class="row mt-3">
    <div class="col-12">
      <div class="card shadow-sm">
        <div class="card-body py-3">
          <div class="d-flex align-items-center">
            <div class="me-3">
              <i class="fa fa-user-circle text-primary" style="font-size: 2.5rem;"></i>
            </div>
            <div>
              <h5 class="mb-1">Welcome, {{ currentUser?.fullName || currentUser?.userName }}!</h5>
              <p class="text-muted mb-0"><small>{{ currentUser?.emailAddress }}</small>
                <span class="badge bg-danger ms-2" *ngIf="currentUser?.isSuperAdmin">Super Admin</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Statistics Cards -->
  <div class="row mt-3">
    <div class="col-md-3">
      <div class="card stat-card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="text-muted mb-1">Total Licenses</p>
              <h3 class="mb-0 fw-bold">{{ totalLicenses }}</h3>
            </div>
            <div class="stat-icon bg-primary">
              <i class="fa fa-key"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card stat-card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="text-muted mb-1">Demo Licenses</p>
              <h3 class="mb-0 fw-bold text-warning">{{ demoLicenses }}</h3>
            </div>
            <div class="stat-icon bg-warning">
              <i class="fa fa-flask"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card stat-card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="text-muted mb-1">Standard Licenses</p>
              <h3 class="mb-0 fw-bold text-info">{{ standardLicenses }}</h3>
            </div>
            <div class="stat-icon bg-info">
              <i class="fa fa-certificate"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card stat-card shadow-sm">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <p class="text-muted mb-1">Total Users</p>
              <h3 class="mb-0 fw-bold text-success">{{ totalUsers }}</h3>
            </div>
            <div class="stat-icon bg-success">
              <i class="fa fa-users"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="row mt-4">
    <!-- License Distribution Chart -->
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm h-100">
        <div class="card-header bg-white border-bottom">
          <h5 class="mb-0">
            <i class="fa fa-chart-pie me-2 text-primary"></i>License Distribution
          </h5>
        </div>
        <div class="card-body">
          <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted mt-2">Loading license data...</p>
          </div>
          <div *ngIf="!isLoading && totalLicenses === 0" class="text-center py-5">
            <i class="fa fa-inbox text-muted" style="font-size: 3rem;"></i>
            <p class="text-muted mt-3">No licenses found</p>
          </div>
          <div *ngIf="!isLoading && totalLicenses > 0" class="chart-container">
            <canvas #licenseChart></canvas>
          </div>
        </div>
      </div>
    </div>

    <!-- User Activity Chart -->
    <div class="col-lg-6 mb-4">
      <div class="card shadow-sm h-100">
        <div class="card-header bg-white border-bottom">
          <h5 class="mb-0">
            <i class="fa fa-chart-bar me-2 text-success"></i>User Activity Status
          </h5>
        </div>
        <div class="card-body">
          <div *ngIf="isLoading" class="text-center py-5">
            <div class="spinner-border text-success" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted mt-2">Loading user data...</p>
          </div>
          <div *ngIf="!isLoading && totalUsers === 0" class="text-center py-5">
            <i class="fa fa-users text-muted" style="font-size: 3rem;"></i>
            <p class="text-muted mt-3">No users found</p>
          </div>
          <div *ngIf="!isLoading && totalUsers > 0" class="chart-container">
            <canvas #userChart></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick Stats -->
  <div class="row mt-2">
    <div class="col-md-6">
      <div class="card shadow-sm">
        <div class="card-body">
          <h6 class="card-title text-muted mb-3"><i class="fa fa-users me-2"></i>User Status Breakdown</h6>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span><i class="fa fa-circle text-success me-2"></i>Active Users</span>
            <span class="badge bg-success">{{ activeUsers }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span><i class="fa fa-circle text-danger me-2"></i>Inactive Users</span>
            <span class="badge bg-danger">{{ inactiveUsers }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card shadow-sm">
        <div class="card-body">
          <h6 class="card-title text-muted mb-3"><i class="fa fa-key me-2"></i>License Type Breakdown</h6>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span><i class="fa fa-circle text-warning me-2"></i>Demo Licenses</span>
            <span class="badge bg-warning">{{ demoLicenses }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <span><i class="fa fa-circle text-info me-2"></i>Standard Licenses</span>
            <span class="badge bg-info">{{ standardLicenses }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
